<template>
  <div
    v-if="visible"
    class="global-message-container"
    :class="{ 'login-required-container': isLoginRequired }"
  >
    <div
      class="message-popup"
      :class="{
        success: isSuccess,
        error: isError,
        'login-required': isLoginRequired,
      }"
    >
      {{ message }}
    </div>
  </div>
</template>

<script setup>
import { useMessagePopup } from '@/features/message/composables/useMessagePopup'

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
  duration: {
    type: Number,
    default: 2000,
  },
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['update:visible'])

const { isSuccess, isError, isLoginRequired } = useMessagePopup(props, emit)
</script>

<style scoped src="@/features/message/styles/MessagePopup.css"></style>
